module.exports = __webpack_public_path__ + "img/coin.7978abda.png";